import i18next from "i18next";

i18next.addResources("es", "LoadingScreen", {
  text: "Cargando datos",
});
i18next.addResources("en", "LoadingScreen", {
  text: "Loading data",
});
